<template>
  <div>
    <Header>
      <MonthSelect />
    </Header>
    <main>
      <Masonry></Masonry>
    </main>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "@/components/layout/Header.vue";
import MonthSelect from "@/components/components/MonthSelect.vue";
import Masonry from "@/components/components/Masonry.vue";

export default {
  name: "home",
  components: {
    Header,
    MonthSelect,
    Masonry
  }
};
</script>
